/* 
    用来放置一些全局方法的
	import operate from "@/common/operate.js"
*/
import tools from './tools';

export default {
    //复制文本
    copy: function(text){
        // navigator clipboard 需要https等安全上下文
        if (tools.isIos() && navigator.clipboard && window.isSecureContext) {
            // navigator clipboard 向剪贴板写文本
            return navigator.clipboard.writeText(text);
        } else {
            // 创建text area
            let textArea = document.createElement("textarea");
            textArea.value = text;
            // 使text area不在viewport，同时设置不可见
            textArea.style.position = "absolute";
            textArea.style.opacity = 0;
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((resolve, reject) => {
                // 执行复制命令并移除文本框
                document.execCommand('copy') ? resolve() : reject();
                textArea.remove();
            });
        }
    },
    showMask: function(param = {}){
        let { 
            zIndex = tools.getZIndex(),
            background = "rgba(0,0,0,0.5)"
        } = param;
        if(masks.length){
            let maskDom = document.body.querySelector('.popup__mask');
            maskDom.style.background = background;
            maskDom.style.zIndex = zIndex;
        }else{
            let maskDom = document.createElement('div');
            maskDom.className = `popup__mask`;
            maskDom.style.width = "100%";
            maskDom.style.height = "100%";
            maskDom.style.userSelect = "none";
            maskDom.style.background = background;
            maskDom.style.position = "fixed";
            maskDom.style.top = "0";
            maskDom.style.left = "0";
            maskDom.style.zIndex = zIndex;
            document.body.appendChild(maskDom);
            maskDom.classList.add('fade-in');
        }
        masks.push({ background, zIndex });
    },
    hideMask: function(){
        let maskDom = document.body.querySelector('.popup__mask');
        if(!maskDom) return;
        masks.splice(-1);
        if(masks.length > 0){
            let { background, zIndex } = masks[masks.length - 1];
            maskDom.style.background = background;
            maskDom.style.zIndex = zIndex;
        }else{
            maskDom.classList.add('fade-out');
            maskDom.style.opacity = 0;
            setTimeout(()=>{
                document.body.removeChild(maskDom);
            }, 200)
        }
    },
    hideAllMask: function(){
        let maskDom = document.body.querySelector('.popup__mask');
        if(!maskDom) return;
        maskDom.classList.add('fade-out');
        maskDom.style.opacity = 0;
        setTimeout(()=>{
            masks = [];
            document.body.removeChild(maskDom);
        }, 200)
    },
}